import {ClientEnvsSchema} from '@/src/config.schema';
import type {z} from 'zod';

const AppConfigSchema = ClientEnvsSchema.readonly();

declare global {
	type AppConfig = z.infer<typeof AppConfigSchema>;

	interface Window {
		readonly __APP_CONFIG: AppConfig;
	}
}

export function setupAppConfig(input: unknown) {
	const value = AppConfigSchema.parse(input);
	Object.defineProperty(window, '__APP_CONFIG', {
		configurable: false,
		writable: false,
		value,
	});
	return value;
}
